<template>
  <div
    v-if="props.show && results.length"
    :class="
      mode === 'dark'
        ? 'bg-dark-70 border-dark-50 divide-dark-50 shadow-darkChat'
        : 'bg-white-100 divide-gray-20 shadow-chat'
    "
    class="max-h-[200px] overflow-y-auto absolute top-full border rounded-lg w-full mt-1 divide-y z-50"
  >
    <div
      v-for="(report, index) in results"
      :key="index"
      class="cursor-pointer px-2 py-3 flex text-[15px]"
      @click="emit('onSelect', report, props.promptID)"
    >
      {{ report.query }}
    </div>
  </div>
</template>
<script setup lang="ts">
interface Props {
  show: boolean;
  results: Array<{ query: string }>;
  promptID?: string | number;
  mode: string;
}
const props = withDefaults(defineProps<Props>(), {
  show: false,
  promptID: "",
});
const emit = defineEmits(["onSelect"]);
</script>
